/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React, { Component, useState, useEffect, useRef } from "react";
import { Collapse } from "react-bootstrap";
import { NavLink } from "react-router-dom";
// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import DefaultNavbarLinks from "../Navbars/DefaultNavbarLinks";

// logo for sidebar
import logo from "./../../logo.svg";

import DataService from "../../services/data.service"
//import TranslationService from "../../services/translation.service";
import MenuItem from "./MenuItem";
import { useAuth } from "./../../contexts/authContext";
import { useTranslations } from './../../contexts/translationContext';
import { MenuItemModel } from "./../../types/MenuItemModel";

var ps: PerfectScrollbar;

export interface SidebarProps {
    color: string
    minimized: boolean
    hasImage: boolean
    backgroundImageUrl: string
}

const DefaultSidebar: React.FC<SidebarProps> = ({ color, minimized, hasImage, backgroundImageUrl }) => {
    const [openAvatar, setOpenAvatar] = useState<boolean>(false);
    const [menuItems, setMenuItems] = useState<MenuItemModel[]>([]);
    const [width, setWidth] = useState<number>(window.innerWidth);
    const [translations, setTranslations] = useState<Record<string, string>>({});
    const { translate } = useTranslations();

    const isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;

    const { user } = useAuth();

    useEffect(() => {
        getMenuItems();
        getTranslations();
    }, [user?.language])

    const sidebarRef = useRef<HTMLDivElement>(null);

    // if the windows width changes CSS has to make some changes
    // this functions tell react what width is the window
    function updateDimensions() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            setTimeout(() => {
                if (ps)
                    ps.update();
            }, 350);
        }

        updateDimensions();

        // add event listener for windows resize
        window.addEventListener("resize", updateDimensions);

        // if you are using a Windows Machine, the scrollbars will have a Mac look
        if (sidebarRef.current) {
            if (navigator.platform.indexOf("Win") > -1) {
                ps = new PerfectScrollbar(sidebarRef.current, {
                    suppressScrollX: true,
                    suppressScrollY: false
                });
            }
        }
        //getMenuItems();
        //getTranslations();

        return function cleanup() {
            window.removeEventListener("resize", updateDimensions);

            // we need to destroy the false scrollbar when we navigate
            // to a page that doesn't have this component rendered
            if (navigator.platform.indexOf("Win") > -1) {
                ps.destroy();
            }
        }
    }, []);

    function getTranslations() {
        translate('My Profile', 'Side Menu').then(translation => setTranslation('MyProfile', translation));
        translate('My Inbox', 'Side Menu').then(translation => setTranslation('MyInbox', translation));
        translate('My Tasks', 'Side Menu').then(translation => setTranslation('MyTasks', translation));
    }

    function setTranslation(key, translation) {
        translations[key] = translation;
        setTranslations(translations);
    }

    function getMenuItems() {
        DataService.get<MenuItemModel[]>(`api/v1/menuitems/sidemenu`)
            .then(response => setMenuItems(response))
            .catch(e => { console.log(e); });
    }

    function createMenus(menuitems: MenuItemModel[]) {
        return menuitems.map((menuitem, key) => {
            return <MenuItem menuItem={menuitem} key={menuitem.id} />;
        });
    };

    return (
        <div className="sidebar" data-color={color} data-image={backgroundImageUrl} >
            {hasImage ? (<div className="sidebar-background" style={{ backgroundImage: "url(" + backgroundImageUrl + ")" }} />) : ("")}
            <div className="logo">
                <a href="/" className="simple-text logo-mini" >
                    <div className="logo-img">
                        <img src={logo} alt="react-logo" />
                    </div>
                </a>
                <a href="/" className="simple-text logo-normal">
                    {user ? user.tenant : ""}
                </a>
            </div>
            <div id="sidebar-wrapper" className="sidebar-wrapper" ref={sidebarRef} >
                {user && (
                    <div className="user">
                        <div className="photo">
                            <img src={user.thumbnailUrl} alt="Avatar" />
                        </div>
                        <div className="info">
                            <a onClick={e => { e.preventDefault(); setOpenAvatar(!openAvatar); }} >
                                <span>
                                    {user ? user.name : "unauthenticated user!"}<b className={openAvatar ? "caret rotate-180" : "caret"} />
                                </span>
                            </a>
                            <Collapse in={openAvatar}>
                                <ul className="nav">
                                    <NavLink
                                        className="nav-link"
                                        state={{ title: user?.name, fromMenu: true }}
                                        to={{ pathname: '/plm/UserManagement/User/' + user?.userId }}
                                    >
                                        <>
                                            <i className='fa fa-id-badge' />
                                            <p>{translations.MyProfile}</p>
                                        </>
                                    </NavLink>
                                    <NavLink
                                        className="nav-link"
                                        state={{ title: translations.MyTasks, fromMenu: true }}
                                        to={{ pathname: '/plm/workflow/mytasks' }}
                                    >
                                        <>
                                            <i className='fa fa-gears' />
                                            <p>{translations.MyTasks}</p>
                                        </>
                                    </NavLink>
                                </ul>
                            </Collapse>
                        </div>
                    </div>
                )}
                <ul className="nav">
                    {/*
                        If we are on responsive, we want both links from navbar and sidebar
                        to appear in sidebar, so we render here HeaderLinks
                    */}
                    {/*width <= 992 ? <DefaultNavbarLinks /> : null*/}
                    {/*
                        here we render the links in the sidebar if the link is simple,
                        we make a simple link, if not, we have to create a collapsible group,
                        with the speciffic parent button and with it's children which are the links
                    */}
                    {createMenus(menuItems)}
                </ul>
            </div>
        </div>
    );
}
export default DefaultSidebar;